import { Navigate, Outlet } from "react-router-dom";
import { isAdminAuthenticated } from "../features/adminAuth/adminAuthStorage";

const AdminPublicRoute = () => {
  if (isAdminAuthenticated()) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return <Outlet />;
};

export default AdminPublicRoute;
